import { IMeasuresSummaryViewModel } from '../models/interfaces';
import { MeasuresHandle } from './measures-handle';

export class MeasuresSummaryViewModel implements IMeasuresSummaryViewModel {
    // data members

    visible = false;

    constructor() {
        // This is intentional
    }

    private _measuresHandle = new MeasuresHandle();

    // constructor

    get measuresHandle() {
        return this._measuresHandle;
    }
}
